// extracted by mini-css-extract-plugin
export default {"title":"b2e0383d10","bld":"b0151e1b94"};